export default __webpack_public_path__ + "769811b1aa3670418303bf147a0a2a86.png";